/**
 * Session-analysis tuning configuration — THE place a human edits to tune
 * the analysis. One small file per area; every knob documents its unit,
 * default, effect, and raise/lower guidance.
 *
 * After editing: `npm run build` in src/PitBrain.Shared, then restart the
 * mobile bundler / rebuild the web app. Values here are compile-time
 * constants — there is no runtime override mechanism (by design, pass 24).
 */
export * from './lapFiltering'
export * from './consistencyScoring'
export * from './focusZones'
export * from './ratingBands'
export * from './zoneDetection'
export * from './chartDisplay'
export * from './accelConsistency'
export * from './gpsDerivedAccel'
export * from './gpsSpeedSanitization'
export * from './telemetryChecks'
export * from './imuVibrationGate'
export * from './leanDisplay'
